import dayjs from 'dayjs';
import httpClient from '../httpClient';

const namingTranslator = {
  identification_data: '1_DatosIdentificacion',
  education_data: '2_ListadoFormacion',
  experience_data: '3_ListadoExperiencia',
  icfes_experience_data: '4_ListadoExperienciaIcfes',
  certifications_data: '4_ListadoOtrasCertificaciones',
};

const makeBlobDownload = (report_name, rdata) => {
  const url = window.URL.createObjectURL(new Blob([rdata]));

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `${namingTranslator[report_name]}_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`,
  );

  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const getYears = async () => {
  return await httpClient.get('announcement_reports_selectors/years');
};

const getAnnouncements = async (year) => {
  return await httpClient.get(
    `announcement_reports_selectors/announcements/?filter[year]=${year}`,
  );
};

const getReport = async (report_name, announcements) => {
  const response = await httpClient.get(
    `announcement_reports/${report_name}/?announcements=${announcements.join(',')}`,
    { responseType: 'blob' },
  );
  makeBlobDownload(report_name, response.data);
};

export { getYears, getAnnouncements, getReport };
